import type { PendingIngestQuestion } from '@axilon-apps/domains-ontology-ui-state'

export function newestPendingQuestionId(
  questions: readonly PendingIngestQuestion[]
): string | null {
  let newest: PendingIngestQuestion | null = null
  let newestTime = Number.NEGATIVE_INFINITY

  for (const question of questions) {
    const parsedTime = Date.parse(question.askedAt)
    const questionTime = Number.isNaN(parsedTime) ? Number.NEGATIVE_INFINITY : parsedTime
    if (newest === null || questionTime > newestTime) {
      newest = question
      newestTime = questionTime
    }
  }

  return newest?.writeId ?? null
}

export function shouldRequestSessionAttention(
  lastSeenQuestionId: string | null | undefined,
  currentQuestionId: string | null
): boolean {
  return currentQuestionId !== null && currentQuestionId !== lastSeenQuestionId
}
